import { Routes } from '@angular/router';
import { devToolsGuard } from '../../core/guards/dev-tools.guard';
import { roleGuard } from '../../core/guards/role.guard';

export const devToolsRoutes: Routes = [
  {
    path: 'dev-tools',
    canActivate: [devToolsGuard, roleGuard],
    data: {
      roles: ['ROLE_SUPER_ADMIN', 'ROLE_COUNTRY_ADMIN', 'ROLE_IMF_ADMIN', 'ROLE_OPERATIONS', 'ROLE_SUPPORT'],
    },
    loadComponent: () => import('./dev-tools-page').then((m) => m.DevToolsPage),
  },
];
